import * as React from 'react'
import { ReactElement, useEffect, useState } from 'react'
import { MailFolder } from '@microsoft/microsoft-graph-types'
import BaseFolderCombobox, { BaseFolderComboboxProps, getRootFolders } from './BaseFolderCombobox'

export type RootFolderComboboxProps = Omit<BaseFolderComboboxProps<MailFolder>, 'entities' | 'getEntityLabel' | 'getEntityValue'>

export default function RootFolderCombobox(props: RootFolderComboboxProps): ReactElement {
    const [entities, setEntities] = useState<MailFolder[]>([])

    useEffect(() => {
        if (props.rootFolderId.loaded && props.folders.loaded) {
            setEntities(getRootFolders(props))
        }
    }, [props.rootFolderId.data, props.folders.data])

    return (
        <BaseFolderCombobox<MailFolder>
            entities={entities}
            filter={folder => folder.parentFolderId === props.rootFolderId.data}
            getEntityLabel={(entity: MailFolder) => entity.displayName}
            getEntityValue={(entity: MailFolder) => entity.id}
            {...props}
        />
    )
}
